export const getDateDifference = (date) => {
    const today = new Date();
    const otherDate = new Date(date);
    const diffMs = otherDate - today; // milliseconds between now & Christmas
    const diffDays = Math.floor(diffMs / 86400000); // days
    const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    return { diffDays, diffHrs, diffMins };
};
